<template>
  <div class="space-between-y">
    <el-dialog :visible.sync="detail.dialog" width="800px" title="服务详情">
      <teacher-service-detail :id="detail.service.id" v-if="detail.dialog"
                              @examined="handleExamined"></teacher-service-detail>
      <teacher-service-examine-btn :service="detail.service" @examined="handleExamined"></teacher-service-examine-btn>
    </el-dialog>
    <div class="both-sides">
      <div class="space-between-x container-left">
        <input-item label="按关键字搜索">
          <el-input clearable v-model="filter.keyword" placeholder="请输入关键字"></el-input>
        </input-item>
        <input-item label="审核状态">
          <el-select @change="getData" clearable v-model="filter.status" placeholder="请选择审核状态">
            <el-option v-for="item in option.examine" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </input-item>
        <input-item width="300" label="服务标签">
          <el-select @change="getData" multiple clearable filterable v-model="filter.tagIds" placeholder="请选择标签">
            <el-option-group
                v-for="group in option.tag"
                :key="group.id"
                :label="group.name">
              <el-option
                  v-for="tag in group.tags"
                  :key="tag.id"
                  :label="tag.name"
                  :value="tag.id">
              </el-option>
            </el-option-group>
          </el-select>
        </input-item>
        <input-item>
          <el-button type="primary" @click="getData()">搜索</el-button>
        </input-item>

      </div>
      <input-item>
        <el-button type="primary" @click="handleTagManage">需求及服务标签管理</el-button>
      </input-item>

    </div>

    <el-table :data="list" border stripe>
      <el-table-column prop="id" label="id" width="50"></el-table-column>
      <el-table-column prop="name" label="服务名称">
        <template slot-scope="scope">
          <line-overflow :content="scope.row.name"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="服务描述">
        <template slot-scope="scope">
          <line-overflow :content="scope.row.desc"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column prop="examine" label="审核状态">
        <template slot-scope="scope">
          <span class="examine-status" v-if="scope.row.examine === 'PENDING'" style="color: #409EFF">待审核</span>
          <span class="examine-status" v-else-if="scope.row.examine === 'APPROVED'"
                style="color: #67C23A">审核通过</span>
          <span class="examine-status" v-else-if="scope.row.examine === 'REJECTED'"
                style="color: #F56C6C">审核失败</span>
        </template>
      </el-table-column>
      <el-table-column prop="onSale" label="是否发布">
        <template slot-scope="scope">
          {{ scope.row.onSale ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column prop="price" label="价格" width="120">
        <template slot-scope="scope">
          {{ scope.row.price }} 元
        </template>
      </el-table-column>
      <el-table-column v-if="false" prop="teacherId" label="teacherId"></el-table-column>
      <el-table-column prop="teacherName" label="教师名称"></el-table-column>
      <el-table-column label="操作" width="60">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="handleShow(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-model="page" @updated="getData()"></pagination>


  </div>
</template>

<script>
import {wmsRouter} from "@/router/wmsRouter";
import Pagination from "@/components/base/layout/Pagination.vue";
import {miuTeacherService} from "@/api/miu/teacherService";
import InputItem from "@/components/base/layout/InputItem.vue";
import {miuTag} from "@/api/miu/tag";
import TeacherServiceDetail from "@/components/miu/TeacherServiceDetail.vue";
import TeacherServiceExamineBtn from "@/components/miu/TeacherServiceExamineBtn.vue";
import LineOverflow from "@/components/base/layout/text/LineOverflow.vue";

export default {
  name: 'MiuTeacherService',
  components: {
    LineOverflow,
    TeacherServiceExamineBtn,
    TeacherServiceDetail,
    InputItem,
    Pagination
  },

  data() {
    return {
      list: [],

      page: {
        size: 10,
        current: 1,
        total: 0,
      },

      option: {
        tag: [],
        examine: [
          {
            label: '全部',
            value: null
          },
          {
            label: '待审核',
            value: "PENDING"
          },
          {
            label: '审核通过',
            value: "APPROVED"
          },
          {
            label: '审核失败',
            value: "REJECTED"
          },
        ],
      },

      filter: {
        keyword: "",
        status: null,
        tagIds: [],
      },

      detail: {
        dialog: false,
        service: null,

      },


    };
  },

  created() {
    this.getTagOption();

    this.getData();

  },

  methods: {
    handleExamined() {
      this.detail.dialog = false;
      this.detail.service = null;
      this.getData();
    },

    handleShow(item) {
      this.detail.service = item;
      this.detail.dialog = true;
    },

    handleTagManage() {
      wmsRouter.miu.teacherService.tagManage();
    },

    getData() {
      miuTeacherService.list(this.page.size, this.page.current, this.filter.status, this.filter.keyword).then(res => {
        let page = res.data;
        this.page.total = page.total;
        this.list = page.list;
      });
    },

    getTagOption() {
      miuTag.list().then(res => {
        let groups = res.data;

        this.option.tag = groups.map(group => {
          let tags = group.tags.map(tag => {
            return {
              name: tag.name,
              id: tag.id,
            }
          });
          return {
            id: group.id,
            name: group.name,
            tags,
          }
        });
      })
    },

  },


};
</script>

<style scoped>

.examine-status {
  font-size: 13px;
  background: #f6f6f6;
  border-radius: 6px;
  padding: 1px 5px;
}
</style>
